export const 일차_디데이 = '2024-07-03 15:00:00';
export const 이차_디데이 = '2024-08-01 23:59:59';
export const 신청_마감_디데이 = '2024-07-08 23:59:59';
